import { rankingData } from '@/mocks/homeData';

const rankColors: Record<number, string> = {
  1: 'bg-primary-500 text-background-50',
  2: 'bg-primary-400 text-background-50',
  3: 'bg-primary-300 text-background-50',
};

const changeIcons: Record<string, string> = {
  up: 'ri-arrow-up-line text-primary-600',
  new: 'ri-sparkling-line text-accent-600',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-primary-100 text-primary-700 rounded-full mb-3">
            人气排行
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            热门榜单
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            当前最受读者欢迎的热门漫画排行
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {rankingData.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 md:p-5 bg-background-100 rounded-2xl transition-all duration-300 hover:-translate-x-1 cursor-pointer"
            >
              <div
                className={`w-9 h-9 rounded-xl flex items-center justify-center text-sm font-bold flex-shrink-0 ${
                  rankColors[item.rank] || 'bg-secondary-100 text-secondary-700'
                }`}
              >
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2.5">
                  <span className="text-base font-semibold text-foreground-800">
                    {item.title}
                  </span>
                  <span className="px-2 py-0.5 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>

              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-sm text-foreground-500">{item.heat}</span>
                <i className={`${changeIcons[item.change] || 'ri-subtract-line text-foreground-400'}`}></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}